import { Box, CircularProgress } from "@mui/material";

export default function PageLoader({ height = "100vh" }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={height}
    >
      <CircularProgress />
    </Box>
  );
}
